import {
  resolveIntlMessageLocale,
  SUPPORTED_INTL_MESSAGE_LOCALES,
} from '@/i18n/intl-message-locales';
import { type AvailableLocale } from '@/i18n/language-provider/shared';

export { resolveIntlMessageLocale, SUPPORTED_INTL_MESSAGE_LOCALES };

/**
 * `whoami.locale` / `users.locale` and browser language can be BCP-47 (e.g. de-DE) or short codes;
 * this maps to the intl message catalog key we have strings for.
 */
export function getInitialBrowserLocale(): AvailableLocale {
  if (typeof window === 'undefined') return 'en-US';
  return resolveUserLocaleString(window.navigator.language, 'en-US');
}

export function resolveUserLocaleString(
  raw: string | undefined,
  fallback: AvailableLocale,
): AvailableLocale {
  return resolveIntlMessageLocale(raw, fallback);
}
